(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 76276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(76187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/layouts/auth/index.tsx + 7 modules
var auth = __webpack_require__(64309);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/button/index.tsx
var components_button = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(92432);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(27643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/graphql/mutations/auth.mutation.ts
var auth_mutation = __webpack_require__(29348);
;// CONCATENATED MODULE: ./src/components/confirmation-page/index.tsx










// const isProd = process.env.NODE_ENV === "production";
var PinInput = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 524).then(__webpack_require__.t.bind(__webpack_require__, 74524, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74524)
            ];
        }
    },
    ssr: false
});
var ConfirmationForm = function(props) {
    var setAccessToken = (0,store/* default */.Z)(function(state) {
        return state.setAccessToken;
    });
    var setRefreshToken = (0,store/* default */.Z)(function(state) {
        return state.setRefreshToken;
    });
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(auth_mutation/* ResendVerifyPhoneOTP */.H3), 2), resendFn = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), code = ref1[0], setCode = ref1[1];
    react.useEffect(function() {
        if (code.length === 5) {
            if (props.confirmSignUp) {
                props.confirmSignUp({
                    otp: code,
                    phone: props.phoneNumber
                }).then(function(res) {
                    var ref, ref1;
                    if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.verifyPhone.access_token) {
                        setAccessToken(res.data.verifyPhone.access_token);
                    }
                    if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.verifyPhone.refresh_token) {
                        setRefreshToken(res.data.verifyPhone.refresh_token);
                    }
                    if (props.nextPage) {
                        router.push("/".concat(props.nextPage));
                    } else {
                        router.push("/");
                    }
                }).catch(function(error) {
                    return dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "toast",
                        children: error.message
                    }));
                });
            }
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        code
    ]);
    var handleSubmit = function(event) {
        event.preventDefault();
        if (code.length === 5) {
            if (props.confirmSignUp) {
                props.confirmSignUp({
                    otp: code,
                    phone: props.phoneNumber
                }).then(function(res) {
                    var ref, ref1;
                    if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.verifyPhone.access_token) {
                        setAccessToken(res.data.verifyPhone.access_token);
                    }
                    if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.verifyPhone.refresh_token) {
                        setRefreshToken(res.data.verifyPhone.refresh_token);
                    }
                    if (props.nextPage) {
                        router.push("/".concat(props.nextPage));
                    } else {
                        router.push("/");
                    }
                }).catch(function(error) {
                    return dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "toast",
                        children: error.message
                    }));
                });
            }
        } else {
            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "toast",
                children: "OTP is too short!"
            }));
        }
    };
    var handleResend = function() {
        resendFn({
            phone: props.phoneNumber
        }).then(function(res) {
            if (res.data) {
                dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "toast",
                    children: [
                        "OTP has been sent to",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold",
                            children: props.phoneNumber
                        })
                    ]
                }));
            }
        }).catch(function() {
            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "toast",
                children: [
                    "Couldn't send OTP to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold",
                        children: props.phoneNumber
                    })
                ]
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-lg -mb-12 px-4 w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "font-libre text-2xl mb-3",
                    children: "Confirmation"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base font-light font-sfpro",
                    children: "A confirmation OTP has been sent to your Whatsapp Account. Kindly input the digits or tap on the link to confirm your number"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "mt-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PinInput, {
                            length: 5,
                            focus: true,
                            initialValue: "",
                            // secret
                            onChange: function(value) {
                                setCode(value);
                            },
                            type: "numeric",
                            inputMode: "number",
                            style: {
                                padding: "10px",
                                display: " flex",
                                justifyContent: " center",
                                alignItems: " center",
                                gap: "0.5rem",
                                width: "100%",
                                maxWidth: "370px",
                                margin: "0 auto"
                            },
                            inputStyle: {
                                borderColor: "#808080",
                                width: "17.5%",
                                height: "78px",
                                fontSize: "2.25rem",
                                borderRadius: "2px"
                            },
                            inputFocusStyle: {
                                borderColor: "#1fad3e",
                                caretColor: "#1fad3e"
                            },
                            onComplete: function(value) {
                                if (value.length === 5) {}
                            },
                            autoSelect: true,
                            regexCriteria: /^[ A-Za-z0-9_@./#&+-]*$/
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                loader: props.fetching,
                                disabled: props.fetching,
                                type: "submit",
                                label: "Confirm OTP",
                                children: "Confirm OTP"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "font-sfpro mt-4 font-light text-sm mx-auto text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "Expires in",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-inawo-green font-medium",
                                            children: "15 minutes"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " ",
                                        "Didn\u2019t get a message?",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: handleResend,
                                            type: "button",
                                            className: "text-inawo-green font-medium underline",
                                            children: "RESEND"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var confirmation_page = (ConfirmationForm);

// EXTERNAL MODULE: ./src/components/input-phone/index.tsx
var input_phone = __webpack_require__(39652);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(61325);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/icon/index.tsx + 41 modules
var icon = __webpack_require__(46679);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/register/index.tsx




















var schema = es/* object */.Ry({
    firstName: es/* string */.Z_().min(2, "Please input a first name with at least 2 characters").trim("Please remove leading and trailing spaces").required("Please input your first name"),
    lastName: es/* string */.Z_().min(2, "Please input a last name with at least 2 characters").trim("Please remove leading and trailing spaces").required("Please input your last name"),
    email: es/* string */.Z_().email("Please input a valid email").trim("Please remove leading and trailing spaces").required("Please input your email"),
    password: es/* string */.Z_().min(6, "Please use a passowrd of at least 6 characters").required("Please input your password")
}).required();
var RegisterForm = function(param) {
    var phoneNumber = param.phoneNumber, setPhoneNumber = param.setPhoneNumber, setNextScreen = param.setNextScreen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState("password"), 2), type = ref8[0], setType = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(auth_mutation/* SignupByPhoneNumber */.ji), 2), signUpResult = ref9[0], signUp = ref9[1];
    var ref10 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), register = ref10.register, handleSubmit = ref10.handleSubmit, _formState = ref10.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    var onSubmit = function(data) {
        signUp({
            input: {
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                phone_number: phoneNumber,
                password: data.password
            }
        }).then(function(res) {
            var ref;
            if (res.error) {
                dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "toast",
                    children: res.error.message
                }));
            }
            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.signupByPhoneNumber) {
                setNextScreen(2);
            }
        }).catch(function(error) {
            return dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "toast",
                children: error === null || error === void 0 ? void 0 : error.message
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Inawo Vendors | Register"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Inawo Vendors | Register"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Register on Inawo Vendors"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-libre text-2xl mb-3",
                        children: "Create an Inawo account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base font-light font-sfpro",
                        children: "Sign up to sell your services"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        className: "flex flex-col justify-start items-start gap-6 mt-8 xs:mt-12 w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-start items-start gap-0 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "firstName",
                                        className: "text-sm font-sfpro text-inawo-grey-200",
                                        children: "First Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                        type: "text",
                                        placeholder: "Denzel",
                                        className: "border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
                                    }, register("firstName"))),
                                    ((ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-600 font-sfpro text-sm",
                                        children: errors === null || errors === void 0 ? void 0 : (ref1 = errors.firstName) === null || ref1 === void 0 ? void 0 : ref1.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-start items-start gap-0 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "lastName",
                                        className: "text-sm font-sfpro text-inawo-grey-200",
                                        children: "Last Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                        type: "text",
                                        placeholder: "Washington",
                                        className: "border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
                                    }, register("lastName"))),
                                    ((ref2 = errors.lastName) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-600 font-sfpro text-sm",
                                        children: errors === null || errors === void 0 ? void 0 : (ref3 = errors.lastName) === null || ref3 === void 0 ? void 0 : ref3.message
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_phone/* default */.Z, {
                                placeholder: "+234",
                                name: "Phone",
                                label: "Phone Number(Whatsapp)",
                                value: phoneNumber,
                                setValue: setPhoneNumber
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-start items-start gap-0 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "email",
                                        className: "text-sm font-sfpro text-inawo-grey-200",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                        type: "email",
                                        placeholder: "abc@example.com",
                                        className: "border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
                                    }, register("email"))),
                                    ((ref4 = errors.email) === null || ref4 === void 0 ? void 0 : ref4.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-600 font-sfpro text-sm",
                                        children: errors === null || errors === void 0 ? void 0 : (ref5 = errors.email) === null || ref5 === void 0 ? void 0 : ref5.message
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-start items-start gap-0 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "password",
                                        className: "text-sm font-sfpro text-inawo-grey-200",
                                        children: "Password (minimum of 6 characters)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-start items-center relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: type,
                                                placeholder: "",
                                                className: "border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
                                            }, register("password"))),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setType(function(prev) {
                                                        return prev === "password" ? "text" : "password";
                                                    });
                                                },
                                                className: "absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    iconName: type === "password" ? "eyeClose" : type === "text" ? "eyeOpen" : "eyeClose"
                                                })
                                            })
                                        ]
                                    }),
                                    " ",
                                    ((ref6 = errors.password) === null || ref6 === void 0 ? void 0 : ref6.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-600 font-sfpro text-sm",
                                        children: errors === null || errors === void 0 ? void 0 : (ref7 = errors.password) === null || ref7 === void 0 ? void 0 : ref7.message
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-center font-light text-sm text-inawo-grey mx-auto ",
                                children: [
                                    "By creating an account you agree to our",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "".concat("https://landing-dev.inawo.com/", "/privacy"),
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        className: "font-normal underline",
                                        children: "Privacy Policy"
                                    }),
                                    " ",
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "".concat("https://landing-dev.inawo.com/", "/terms"),
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        className: "font-normal underline",
                                        children: "Terms of Service"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                loader: signUpResult.fetching || isSubmitting,
                                disabled: !isValid || isSubmitting || phoneNumber === "",
                                type: "submit",
                                label: "Create Account",
                                children: "Create Account"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mx-auto font-light font-sfpro text-sm",
                                children: [
                                    "Already have an account?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/login",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "font-medium text-inawo-green",
                                                children: "Log in"
                                            })
                                        })
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "mx-auto -mt-5 font-sfpro text-inawo-black font-light underline text-sm md:text-base",
                                    children: "Skip, to explore services"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Register = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), nextScreen = ref[0], setNextScreen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(auth_mutation/* VerifyPhone */.o7), 2), confirmSignUpResult = ref1[0], confirmSignUp = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), phoneNumber = ref2[0], setPhoneNumber = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), nextPage = ref3[0], setNextPage = ref3[1];
    react.useEffect(function() {
        if (router.query.next) {
            if (router.query.next === "add-a-service") {
                setNextPage("become-a-vendor/add-a-service");
            } else {
                setNextPage(router.query.next);
            }
            router.replace("/login", undefined, {
                shallow: true
            });
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-lg mb-12 w-full px-4",
        children: nextScreen === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
            phoneNumber: phoneNumber,
            setPhoneNumber: setPhoneNumber,
            setNextScreen: setNextScreen
        }) : nextScreen === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_page, {
            fetching: confirmSignUpResult.fetching,
            phoneNumber: phoneNumber,
            confirmSignUp: confirmSignUp,
            setNextScreen: setNextScreen,
            nextPage: nextPage
        }) : null
    });
};
Register.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var register = ((0,next_urql_es/* withUrqlClient */.X)(function(_ssr) {
    return {
        url: "https://staging.inawo.live/query",
        requestPolicy: "cache-and-network",
        fetchOptions: function() {
            return {
                headers: {
                    "x-user-token": (0,storage/* getAccessCookie */.tN)() ? "".concat((0,storage/* getAccessCookie */.tN)()) : ""
                }
            };
        }
    };
}, {
    ssr: false
})(Register));


/***/ }),

/***/ 27643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
;// CONCATENATED MODULE: ./src/store/auth/index.ts

var refreshCookie = (0,storage/* getRefreshCookie */.Qy)();
var accessCookie = (0,storage/* getAccessCookie */.tN)();
var createAuthSlice = function(set) {
    return {
        accessToken: accessCookie ? accessCookie : "",
        setAccessToken: function(arg, ctx) {
            set(function() {
                return {
                    accessToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setAccessCookie */.AA)(arg, ctx);
            } else {
                (0,storage/* setAccessCookie */.AA)(arg);
            }
        },
        refreshToken: refreshCookie ? refreshCookie : "",
        setRefreshToken: function(arg, ctx) {
            set(function() {
                return {
                    refreshToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setRefreshCookie */.gE)(arg, ctx);
            } else {
                (0,storage/* setRefreshCookie */.gE)(arg);
            }
        }
    };
};
/* harmony default export */ var auth = (createAuthSlice);

;// CONCATENATED MODULE: ./src/store/index.ts



// import { immer } from "zustand/middleware/immer";

var useStore = (0,esm/* default */.ZP)()(function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, auth.apply(void 0, (0,_to_consumable_array/* default */.Z)(a)));
});
// const useStore = create<StoreType>()(
//   immer((...a) => ({
//     ...createAuthSlice(...a),
//   }))
// );
/* harmony default export */ var store = (useStore);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [379,88,325,675,586,978,575,838,694,938,774,888,377], function() { return __webpack_exec__(76276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);